import { NgModule } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import {
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  CheckCircle,
  Download,
  Edit,
  Edit2,
  Eye,
  EyeOff,
  HelpCircle,
  Home,
  Info,
  MapPin,
  UploadCloud,
  User,
  X,
  XCircle,
} from 'angular-feather/icons';

// Voir la liste des icones disponible ici : https://github.com/michaelbazos/angular-feather#available-icons
const icons = {
  ArrowLeft,
  ArrowRight,
  Home,
  EyeOff,
  Eye,
  X,
  Info,
  AlertTriangle,
  HelpCircle,
  Edit,
  XCircle,
  UploadCloud,
  MapPin,
  Download,
  Edit2,
  User,
  CheckCircle,
};

@NgModule({
  imports: [FeatherModule.pick(icons)],
  exports: [FeatherModule],
})
export class IconsModule {}
